const SDK_VERSION = '8.1.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
